/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_TitleInputs */



/**
* | output |
* | --- |
* | "Accept Change" |
*
* @param {Spellcheck_Accept_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_title = /** @type {((inputs?: Spellcheck_Accept_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accepter la correction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderung akzeptieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accetta la modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принять изменения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aceptar el cambio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("接受改变")
	if (locale === "ja") return /** @type {LocalizedString} */ ("変更を受け入れる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बदलाव को स्वीकार करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aceitar alteração")
	return /** @type {LocalizedString} */ ("Accept Change")
});